import { matchModel } from "@/game-eft/models/graphql.mjs";
import gql from "@/util/graphql-query.mjs";

export const createPlayer = gql`
  mutation createPlayer($player: CreatePlayerInput!) {
    createPlayer(player: $player) {
      accountId
    }
  }
`;

export const createMatch = gql`
  mutation createMatch($match: CreateMatchInput!) {
    createMatch(match: $match)
  }
`;

export const createPlayerSeasonStat = gql`
  mutation createPlayerSeasonStat(
    $playerSeasonStat: CreatePlayerSeasonStatInput!
  ) {
    createPlayerSeasonStat(playerSeasonStat: $playerSeasonStat) {
      id
    }
  }
`;

export const updatePlayerSeasonStat = gql`
  mutation updatePlayerSeasonStat(
    $playerSeasonStat: UpdatePlayerSeasonStatInput!
  ) {
    updatePlayerSeasonStat(playerSeasonStat: $playerSeasonStat) {
      id
    }
  }
`;

export const getPlayer = gql`
  query player($accountId: String) {
    player(accountId: $accountId) {
      accountId
      id
      isBot
      updatedAt
      username
    }
  }
`;

export const getMatchlist = gql`
  query player($accountId: String, $seasonId: ID, $offset: Int = 5) {
    player(accountId: $accountId) {
      playerMatches(seasonId: $seasonId, first: $offset) {
        gameId
        startedAt
        faction
      }
    }
  }
`;

// Todo: Trim the amount of data received, this was created to receive all data for dev purposes
export const getMatch = gql`
  query getMatch($gameId: String!, $gameMode: TarkovGameMode!) {
    match(gameId: $gameId, gameMode: $gameMode) { ${matchModel} }
  }
`;

export const getPlayerSeasonStat = gql`
  query playerSeasonStat(
    $accountId: String!
    $gameMode: TarkovGameMode!
    $faction: TarkovFaction!
  ) {
    playerSeasonStat(
      accountId: $accountId
      gameMode: $gameMode
      faction: $faction
    ) {
      accountId
      characterId
      createdAt
      damage
      deaths
      experience
      faction
      gameMode
      headshots
      id
      insertedAt
      kills
      level
      loot
      matches
      player {
        accountId
        id
        isBot
        updatedAt
        username
      }
      season {
        id
      }
      updatedAt
      username
    }
  }
`;

export const getPlayerWeaponStat = gql`
  query playerWeaponStats($accountId: String) {
    playerWeaponStats(accountId: $accountId) {
      afflictions
      count
      damageDealt
      damageTaken
      duration
      gameMode
      hitsBody
      hitsChest
      hitsHead
      hitsLeftArm
      hitsLeftLeg
      hitsRightArm
      hitsRightLeg
      hitsStomach
      kills
      shotsLanded
      survived
      totalShots
      weapon {
        id
        longName
        shortName
        uuid
      }
    }
  }
`;

export const getPlayerFactionStat = gql`
  query getFactionStats($accountId: String) {
    player(accountId: $accountId) {
      seasonStats {
        faction
        matches
        loot
        experience
        level
        damage
        kills
        updatedAt
      }
    }
  }
`;

export const getPlayerMapStat = gql`
  query playerMapStats($accountId: String) {
    playerGameMapStats(accountId: $accountId) {
      count
      duration
      kills
      survived
      shotsLanded
      totalShots
      gameMap {
        id
        key
        name
      }
    }
  }
`;

export const getSeasons = gql`
  query seasons {
    seasons {
      id
      startAt
      endAt
    }
  }
`;

export const getLeaderboardsWeapons = gql`
  query LeaderboardsWeapons(
    $seasonId: String
    $gameMode: String
    $faction: String
    $rank: String
  ) {
    executeDatabricksQuery(
      game: TARKOV
      queryName: "prod_weapon_stats"
      params: [
        { name: "season_id", value: $seasonId }
        { name: "game_mode", value: $gameMode }
        { name: "faction", value: $faction }
        { name: "rank", value: $rank }
      ]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const getLeaderboardsMaps = gql`
  query LeaderboardsMaps(
    $seasonId: String
    $gameMode: String
    $faction: String
  ) {
    executeDatabricksQuery(
      game: TARKOV
      queryName: "prod_map_stats"
      params: [
        { name: "season_id", value: $seasonId }
        { name: "game_mode", value: $gameMode }
        { name: "faction", value: $faction }
      ]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const getLeaderboardsPlayers = gql`
  query LeaderboardsPlayers(
    $seasonId: String
    $gameMode: String
    $faction: String
    $page: String
    $rankingMetric: String
  ) {
    executeDatabricksQuery(
      game: TARKOV
      queryName: "prod_leaderboard"
      params: [
        { name: "season_id", value: $seasonId }
        { name: "game_mode", value: $gameMode }
        { name: "ranking_metric", value: $rankingMetric }
        { name: "page", value: $page }
        { name: "faction", value: $faction }
      ]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;

export const getItems = gql`
  query getItems {
    items {
      id
      longName
      shortName
      type
      uuid
    }
  }
`;

export const getFleaMarketData = gql`
  query fleaMarketStats {
    executeDatabricksQuery(
      game: TARKOV
      queryName: "prod_flea_market_stats"
      params: [{ name: "dummy", value: "dummy" }]
    ) {
      metadata {
        byteSize
        lastModified
        statement
        parameters
      }
      payload
    }
  }
`;
